import { Link } from '@tanstack/react-router';
import { ArrowRight, CreditCard } from 'lucide-react';

import { Tooltip } from '@/shared/ui/tooltip';

import { summarizePlan } from '../billing-format';

import type { BillingStatus } from '@mio/shared';

/** Sits above the account row in the sidebar; hidden until billing status is known. */
export function SidebarPlan({
  status,
  collapsed,
}: {
  status: BillingStatus | undefined;
  collapsed: boolean;
}) {
  if (!status?.enabled) return null;
  const summary = summarizePlan(status);
  if (collapsed)
    return (
      <Tooltip label={`Plan · ${summary.title}`}>
        <Link
          to="/account/plan"
          aria-label={`Plan: ${summary.title}`}
          className="hover:bg-surface mx-auto mb-1 flex size-10 items-center justify-center rounded-md"
        >
          <CreditCard className="size-[18px]" strokeWidth={1.7} aria-hidden="true" />
        </Link>
      </Tooltip>
    );
  return (
    <Link to="/account/plan" className="sidebar-plan" aria-label={`Plan: ${summary.title}`}>
      <span className="sidebar-plan-label">Plan</span>
      <span className="sidebar-plan-title">{summary.title}</span>
      {summary.detail ? <span className="sidebar-plan-detail">{summary.detail}</span> : null}
      {summary.upgrade ? (
        <span className="sidebar-plan-upgrade">
          Upgrade <ArrowRight className="size-3.5" aria-hidden="true" />
        </span>
      ) : null}
    </Link>
  );
}
